<div class="container col-sm-8 pt-5 webview text-center" [@flyInOut]="'in'">
  <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
  <div class="col-sm-6 col-md-6 col-xl-5 m-auto text-left">
    <label class="custom-control custom-checkbox chkbox mb-2" for="fixed">
      <input type="checkbox" class="custom-control-input mgntp10" id="fixed" value="Fixed rate" name="producttype"
        [(ngModel)]="hgProductTypes.type1" (click)="getProductType($event)" />
      <label class="custom-control-label font20" for="fixed">Fixed rate</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="variable">
      <input type="checkbox" class="custom-control-input mgntp10" id="variable" value="Variable & index rate" name="producttype"
        [(ngModel)]="hgProductTypes.type2" (click)="getProductType($event)" />
      <label class="custom-control-label font20" for="variable">Variable & index rate</label>
    </label>
  </div>
  <button *ngIf="showbutton" class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'combtn': user_bot}"
    (click)="next();">Next</button>
    <div class="mt-5" >
      <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr text-center">
        <img src="assets/images/flash.png" class="mb-1" />
        <p class="text-center tiphead">JUST AN FYI</p>
        <p class="text-center tipmes" [innerHTML]="questionObj.tip1" ></p>
        <p class="text-center tipmes" [innerHTML]="questionObj.tip2" ></p>


      </div>
    </div>
    <!-- <div class="mt-5" >
      <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr text-center">
        <img src="assets/images/flash.png" class="mb-1" />
        <p class="text-center tiphead">JUST AN FYI</p>
 
      <p class="text-center tipmes">{{questionObj.tip2}}</p>
      </div>
    </div> -->
</div>
<div class="container mobileview px-0" [attr.id]="questionObj._id" style="float:left; margin-top: 2.0rem!important;">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <div class="row col-sm-12 m-auto">
    <div class="col-12 px-0">
      <label class="custom-control custom-checkbox chkbox mb-2" for="fixed_mob">
        <input type="checkbox" class="custom-control-input mgntp10" id="fixed_mob" value="Fixed rate" name="producttype"
          [(ngModel)]="hgProductTypes.type1" (click)="getProductType($event)" />
        <label class="custom-control-label font20" for="fixed_mob">Fixed rate</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="variable_mob">
        <input type="checkbox" class="custom-control-input mgntp10" id="variable_mob" value="Variable & index rate"
          name="producttype" [(ngModel)]="hgProductTypes.type2" (click)="getProductType($event)" />
        <label class="custom-control-label font20" for="variable_mob">Variable & index rate</label>
      </label>
    </div>
    <p class="m-auto text-muted tapmsg">{{questionObj.chkboxtype}}</p>
    <div class="mb-3" style="width:100% !important; text-align: right;">
      <div *ngIf="user_bot" class="ash_box text-right">
        <h1 class="ansMob text-right">{{typeOfProduct}}</h1>
      </div>
    </div>
  </div>
  <div class="col-12 mb-3" *ngIf="showTip">
    <div class="m-auto blockbg boxclr p-2">
      <img src="assets/images/flash.png" class="mb-1" style="margin-left: 48%" />
      <p class="text-center tiphead">JUST AN FYI</p>
      <p class="text-center tipmes" *ngIf="typeOfProduct == 'Fixed rate'">{{questionObj.tip1}}</p>
      <p class="text-center tipmes" *ngIf="typeOfProduct == 'Variable & index rate'">{{questionObj.tip2}}</p>
    </div>
  </div>
</div>